import { config, useTransition } from "@react-spring/web";

import { HaNSensorInformationProps } from "./types";
import { HaNModalHeader, MeetingRoomAvailabilityInformationContent } from "@organisms";
import { useTranslation } from "react-i18next";
import { SensorInformationWrapper } from "./styles";

/**
 * Lists available rooms (horizontally) in Here And Now
 */

export const HaNSensorInformation = ({ onBack, onClose, page, className }: HaNSensorInformationProps) => {
  const { t } = useTranslation();
  const transition = useTransition(page === "sensorInformation", {
    from: { transform: "translate3d(100%, 0, 0)" },
    enter: { transform: "translate3d(0%, 0, 0)" },
    leave: { transform: "translate3d(100%, 0, 0)" },
    config: { ...config.stiff, clamp: true },
  });

  return transition(
    (style, item) =>
      item && (
        <SensorInformationWrapper style={style}>
          <HaNModalHeader
            onBack={onBack}
            onClose={onClose}
            title={t("screen:MeetingRoomDetails")}
          />
          <MeetingRoomAvailabilityInformationContent className={className} />
        </SensorInformationWrapper>
      ),
  );
};
